import { Container } from "react-bootstrap";

const EmrCaseStudy = () => {
    return (
        <section className="case-study-content-block py-5">
            <Container>
                <div>
                    <h2 className="text-primary ft-wt-700 mb-4">
                        Automation Testing for Electronic Medical Records (EMR) Application
                    </h2>

                    <h3 className="text-primary ft-wt-700 mb-3">The Challenge</h3>

                    <p>
                        The EMR platform had grown complex over time, making manual testing
                        extremely time-consuming and error-prone. Testing critical features
                        like patient records, prescriptions, and lab reports required
                        precision and often involved repetitive steps across different user
                        roles such as doctors, nurses, and administrative staff. Frequent
                        updates to comply with healthcare regulations (like HIPAA)
                        introduced new workflows that needed quick and thorough testing.
                        Moreover, ensuring compatibility across devices and browsers further
                        increased the testing overhead.
                    </p>

                    <h3 className="text-primary ft-wt-700 mb-3">The Solution</h3>

                    <p>
                        We implemented a robust test automation framework using Selenium and
                        Cypress for end-to-end and cross-browser testing, and Jest for
                        API-level validations. The tests were structured to be modular and
                        reusable, with environment-specific configurations and role-based
                        flows. The framework was integrated into the CI/CD pipeline,
                        enabling automatic test execution for every code push and nightly
                        builds. Additionally, we used visual regression tools to catch
                        unintended UI changes in sensitive areas like patient charts and
                        prescription views.
                    </p>

                    <h3 className="text-primary ft-wt-700 mb-3">The Benefits</h3>

                    <p>Key advantages achieved with the solution include:</p>
                    <ul>
                        <li>Reduced regression testing time by 70%</li>
                        <li>Faster and safer deployments with automated test feedback</li>
                        <li>Improved accuracy in patient-critical workflows</li>
                        <li>Increased compliance confidence and quality assurance</li>
                        <li>Support for testing across multiple roles and devices</li>
                    </ul>
                </div>
            </Container>
        </section>
    );
};

export default EmrCaseStudy;
